<template>
    <div class="warranty-each-head">
        <div class="row mt-4">
            <div class="cols-sm-12 col-md-12 col-lg-12">
                <h3 class="">Warranties by product</h3>
            </div>

            <div class="col-sm-12 col-md-12 col-lg-12">
                <select name="" id="" v-model="selectedProduct" class="form-control">
                    <option value="">Select product</option>
                    <option v-for="product in products" :value="product.sku" :key="product.sku">{{ product.name }}</option>
                </select>
            </div>

            <template v-if="!loading">
                <div class="col-sm-12 col-md-12 col-lg-12 mt-2" v-if="selectedProduct">
                    <span class="selected-product-requests-count">{{ selectedProductTickets.length }} </span>requests
                </div>

                <div class="col-sm-12 col-md-12 col-lg-12 mt-4" v-if="selectedProduct">
                    <h3>Warranties by part</h3>
                    <ul class="warranty-by-part-list">
                        <li v-for="(ticket, key) in selectedProductTicketsParts" :key="key">
                            <template v-if="ticket.length > 0">
                                <span class="warranty-by-part-list-item-count">{{ ticket.length }}</span>
                                <span class="warranty-by-part-list-item-name">{{ ticket[0].replaced_product_name }}</span>
                            </template>
                        </li>
                    </ul>
                    <div v-if="Object.keys(selectedProductTicketsParts).length === 0">No parts found</div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import AuthApis from '@/controllers/AuthApis';
import Loading from '@/components/Loading';
import Env from '@/env';
export default {
    name: 'RepairEachHead',
    components: {
        Loading
    },
    props: {
        startDate: {
            type: [Date, String],
            required: false,
            default: null
        },
        endDate: {
            type: [Date, String],
            required: false,
            default: null
        }
    },
    data() {
        return {
            selectedProduct: '',
            loading: true,
            totalWarranties: 0,
            products: [],
            selectedProductTickets: [],
            selectedProductTicketsParts: []
        };
    },
    mounted() {
        this.getAllProducts();
    },
    watch: {
        selectedProduct: {
            handler() {
                this.getProductBasedWarranty();
            }
        }
    },
    methods: {
        getAllProducts() {
            let url = `${Env.baseUrl}/auth/fetch-product-with-code`;
            AuthApis.getApi(url)
                .then((res) => {
                    this.products = res.data.payload;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        getProductBasedWarranty() {
            if (!this.selectedProduct) return;
            this.loading = true;
            this.spinner(true);
            let url = `${Env.baseUrl}/v2/superadmin/reg-product/get-repair-product-based`;
            AuthApis.postApi(url, {
                startDate: this.startDate,
                endDate: this.endDate,
                sku: this.selectedProduct
            })
                .then((res) => {
                    this.spinner(false);
                    this.selectedProductTickets = res.data.payload;
                    const groupedMaterials = {};

                    res.data.payload.forEach((ticket) => {
                        ticket.repaired_materials.forEach((material) => {
                            console.log(material);
                            const sku = material.replaced_product_sku || 'unknown';
                            if (!groupedMaterials[sku]) {
                                groupedMaterials[sku] = [];
                            }
                            groupedMaterials[sku].push(material);
                        });
                    });

                    this.selectedProductTicketsParts = groupedMaterials;
                    this.loading = false;
                })
                .catch((err) => {
                    this.loading = false;
                    this.spinner(false);
                    console.log(err);
                });
        }
    }
};
</script>
